/**
 * Centralized constants for the application
 * This ensures consistent URLs across all SEO metadata, sitemaps, and structured data
 */

// Production URL for thehighraysyt.com
export const BASE_URL = "https://www.thehighraysyt.com";

// Brand contact email
export const BRAND_EMAIL = "info@thehighrays.com";

// Phone numbers
export const PHONE_NUMBERS = {
	canada: "+1-416-726-4766",
	india: "+91-827-326-2260",
} as const;
